<script>
  export default {
    name: "WidgetButtonLink",
    props: {
      /** URL string for the button */
      link: {
        type: String,
        default: null
      },
      /** Label for the button */
      label: {
        type: String,
        default: 'Learn More'
      }
    }
  }
</script>

<template>
  <div class="callout--button">
    <a :href="link" class="button--primary m-full">
      {{ label }} <i class="fa fa-caret-right"></i>
    </a>
  </div>
</template>
